<!--
 * @Author: wangwei
 * @Date: 2020-12-29 16:05:36
 * @LastEditTime: 2021-01-09 17:26:39
 * @LastEditors: Please set LastEditors
 * @Description: 账号安全
 * @FilePath: /java-pc/src/views/member/center/Account.vue
-->
<template>
  <div class="sld_account">
    <!-- <MemberTitle :memberTitle="L['账号安全']"></MemberTitle> -->
    <div class="container">
      <div class="title">{{ L['账号安全'] }}
        <span class="title_info">{{ L['建议您开启全部安全设置，以保障账户及资金安全'] }}</span>
      </div>
      <div class="commonContent">
        <div class="item flex_row_start_center">
          <img class="icon_info" 
          v-if="!memberInfo.data.hasLoginPassword"
          src="../../../assets/user/no_password.png" alt="">
          <img class="icon_info" 
          v-else
          src="../../../assets/user/modify_password.png" alt="">
          <div class="item_info flex_row_start_center">
            <span>{{ L['修改登录密码'] }}</span>
            <span class="tips"  v-if="memberInfo.data.hasLoginPassword">{{
              L[
                '定期更换密码有助于账号安全'
              ]
            }}</span>
            <span class="tips" v-else>{{
              L[
                '您还未设置账户登录密码'
              ]
            }}</span>
            <div>
              <span class="oprate pointer" @click="toPage('/member/pwd/login', 'edit')"
                v-if="memberInfo.data.hasLoginPassword">{{ L['修改密码'] }}</span>
              <span class="oprate pointer" @click="toPage('/member/pwd/login', 'set')" v-else>{{ L['设置'] }}</span>
            </div>
          </div>
        </div>
        <div class="item flex_row_start_center">
          <img class="icon_info" 
          src="../../../assets/user/bind_phone.png" alt="">
          <div class="item_info flex_row_start_center">
            <span>{{ L['绑定手机'] }}</span>
            <span class="tips" v-if="memberInfo.data.memberMobile">{{ L['当前验证手机：'] }}{{ memberInfo.data.memberMobile }}{{
              L['']
            }}</span>
            <span class="no tips" v-else>{{ L['尚未绑定手机号'] }}</span>
            <div>
              <span class="oprate pointer" v-if="memberInfo.data.memberMobile" @click="toPage('/member/phone', 'edit')">{{
                L['修改绑定'] }}</span>
              <span class="oprate pointer" @click="toPage('/member/phone', 'bind')" v-else>{{ L['绑定号码'] }}</span>
            </div>
          </div>
        </div>
        <div class="item flex_row_start_center">
          <!-- <img class="icon_info" 
          v-if="!memberInfo.data.memberEmail"
          src="../../../assets/user/no_bind_third.png" alt=""> -->
          <img class="icon_info" 
          src="../../../assets/user/bind_third.png" alt="">
          <div class="item_info flex_row_start_center">
            <span>{{ L['第三方账号绑定'] }}</span>
            <span class="tips" >{{
              L['进行绑定后，可进行快速找回账号及其他操作，保护您的账户安全']
            }}</span>
            <div>
              <span class="oprate pointer" @click="toPage('/member/email', 'edit')">{{
                L['账号管理'] }}</span>
            <!-- <span class="tips" v-if="memberInfo.data.memberEmail">{{ L['绑定邮箱：'] }}{{ memberInfo.data.memberEmail }}，{{
              L['若邮箱已停用，请及时更换']
            }}</span>
            <span class="no tips" v-else>{{ L['尚未绑定邮箱'] }}</span>
            <div>
              <span class="oprate pointer" @click="toPage('/member/email', 'edit')" v-if="memberInfo.data.memberEmail">{{
                L['修改邮箱'] }}</span>
              <span class="oprate pointer" @click="toPage('/member/email', 'bind')" v-else>{{ L['绑定邮箱'] }}</span> -->
            </div>
          </div>
        </div>  
        <div class="item flex_row_start_center">
          <img class="icon_info" 
          src="../../../assets/user/log_off.png" alt="">
          <div class="item_info flex_row_start_center">
            <span>{{ L['注销账号'] }}</span>
            <span class="tips">{{
              L['注销后，其下所有服务、数据及隐秘信息将会被删除无法恢复']
            }}</span>
            <div class="flex_column_center_center">
              <span class="oprate reset pointer" @click="jumpTo()">
                {{ L['申请注销'] }}</span>
            </div>
          </div>
        </div>     
        <!-- <div class="item flex_row_start_center">
          <i :class="{
            iconfont: true,
            'iconjubao': !memberInfo.data.hasPayPassword,
            'iconxuanweimorendizhi': memberInfo.data.hasPayPassword
          }"></i>
          <div class="item_info flex_row_start_center">
            <span>{{ L['支付密码'] }}</span>
            <span class="tips">{{
              L['在使用账户余额时需输入支付密码以保证您的资金安全']
            }}</span>
            <div class="flex_column_center_center">
              <span class="oprate pointer" @click="toPage('/member/pwd/pay', 'edit')"
                v-if="memberInfo.data.hasPayPassword">{{ L['修改密码'] }}</span>
              <span class="oprate pointer" @click="toPage('/member/pwd/pay', 'set')"
                v-if="!memberInfo.data.hasPayPassword">{{ L['设置密码'] }}</span>
              <span class="oprate reset pointer" @click="toPage('/member/pwd/reset', 'reset')"
                v-if="memberInfo.data.hasPayPassword">{{ L['重置密码'] }}</span>
            </div>
          </div>
        </div> -->
      </div>
      <button class="log_off" @click="loginOut()">{{ L['退出登录'] }}</button>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router' //引入路由
import MemberTitle from '../../../components/MemberTitle'
export default {
  name: 'Account',
  components: {
    MemberTitle
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const router = useRouter()
    const L = proxy.$getCurLanguage()
    const store = useStore()
    const memberInfo = reactive({ data: store.state.memberInfo })
    const toPage = (url, type) => {
      router.push({
        path: url,
        query: {
          type
        }
      })
    }
    const goToByPush =(type,param = {})  => {
			router.push({
        path: type,
        query: param
      });
		}
		//退出登录
    // const loginOut = () => {
    //   store.commit("clearAllData"); //清除数据
    //   store.commit('clearCartStorage')
    //   proxy.$socket.disconnect()
    //   goToByPush("/login", {});
    // };
    const loginOut = () => {
      // 获取 access_token 和 refresh_token
      const accessToken = localStorage.getItem("access_token");
      const refreshToken = localStorage.getItem("refresh_token");
      // console.log("llllllll", accessToken)
      let config = {
        'Authorization': "Bearer " + accessToken,
        refresh_token: refreshToken,
      };
      proxy.$post('v3/frontLogin/oauth/logout', config).then(res => {
        if (res.state == 200) {
          // 登出成功后清除本地存储中的令牌和其他用户信息
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
          console.log("Logout successful");

          // 可选：重定向到登录页面或其他处理逻辑
          //window.location.href = "/login";
          let newWin = router.resolve({ path: '/login' });
          window.location.href = newWin.href; 

        } else {
          console.log('Logout failed with status:', res.state);
        }
      });

    };

    // 定义跳转到外部网站的方法
    const jumpTo = () => {
      window.open('https://privacy.asus.com.cn/pi/cn/privacy', '_blank');
    };

    return {
      L,
      memberInfo,
      jumpTo,
      toPage,
      goToByPush,
			loginOut,
    }
  }
}
</script>

<style lang="scss" scoped>
.sld_account {
  width: 1106px;
  float: left;
  margin-left: 10px;

  .container {
    background-color: white;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #eaeaea;
    // padding: 25px 40px;

    .title {
      // font-size: 18px;
      // border-bottom: 1px dashed #eaeaea;
      // padding-bottom: 25px;
      // font-weight: 600;
      border-bottom: 1px solid #EAEDF0 ;
      height: 86px;
			font-family: Microsoft YaHei,Microsoft YaHei ;
			font-weight: 500;
			font-size: 18px;
			color: #000000;
			line-height: 86px;
    	padding-left: 30px;
      .title_info{
        font-family: Microsoft YaHei,Microsoft YaHei ;
        font-weight: 400;
        font-size: 12px;
        color: #888E98;
        line-height: 18px;
        display: inline-block;
        margin-left: 20px;
      }
    }

    .commonContent {
      margin: 35px 0;
      margin: 60px 70px 60px 70px;
      font-size: 14px;

      .item {
        width: 100%;
        border-bottom: 1px solid #EAEDF0;
        box-sizing: border-box;
        padding: 33px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item_info{
          font-family: Microsoft YaHei,Microsoft YaHei ;
          font-weight: 400;
          font-size: 18px;
          color: #000000;
          line-height: 26px;
          margin-right: auto;
          justify-content: space-between;
          align-items: center;
          display: flex;
          width: 100%;
          
        }
        .icon_info{
          width: 32px;
          height: 32px;
          margin-right: 15px;
        }
        // .iconfont {
        //   margin-right: 10px;
        // }

        // .iconjubao {
        //   color: var(--color_main);
        // }

        // .iconxuanweimorendizhi {
        //   color: green;
        // }

        .tips {
          margin-left: 20px;
          margin-right: auto;
          // width: 680px;
          font-family: Microsoft YaHei,Microsoft YaHei ;
          font-weight: 400;
          font-size: 15px;
          color: #888E98;
          line-height: 24px;
        }

        .oprate {
          width: 100px;
          height: 38px;
          background: rgba(234,237,240,0.4);
          border-radius: 2px 2px 2px 2px;
          border: 1px solid #BDBDBD;
          font-family: Microsoft YaHei,Microsoft YaHei;
          font-weight: 400;
          font-size: 15px;
          color: rgba(0,0,0,0.7);
          line-height: 18px;
          text-align: center;
          display: inline-block;
          line-height: 36px;
        }

        .reset {
          margin-top: 10px;
        }
      }
      
    }
    .log_off{
      width: 80px;
      height: 34px;
      background: #1E7CFF;
      border-radius: 2px 2px 2px 2px;
      font-family: Microsoft YaHei,Microsoft YaHei ;
      font-weight: 400;
      font-size: 15px;
      color: #FFFFFF;
      line-height: 32px;
      text-align: center;
      border-color: transparent;
      margin: 0px 80px 70px 946px;
    }
  }
}
</style>

<style lang="scss">
/**
* 解决el-input设置类型为number时，中文输入法光标上移问题
**/
.el-input__inner {
  line-height: 1px !important;
}


</style>
